/* sub class of SLd */

import React, { Component } from "react";
import { data, questions } from './data/data.js'
import { Cards } from './components/Cards/Cards';
import { Question } from "./components/Question/Question";
import { RoundScore } from "./components/RoundScore/RoundScore";
import { Player } from "./components/Player/Player";
import { Header } from "./components/Header/Header.js";
import './familyStyles.css';
import { RoundButtons } from "./components/RoundButtons/RoundButtons.js";

export class Family extends Component {
    state = {
        round: 0,
        error: 0,
        points: [0, 0],
        players: ["player 1", "player 2"],
        cardData: data,
        cardShow: [false, false, false, false, false, false],
        currentPlayer: 0,
        showX: false,
        roundScore: 0,
        gameName: "Family Feud"
    };
    componentDidMount() {
        document.addEventListener("keydown",
            this.handleOnKeyPress, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown",
            this.handleOnKeyPress, false);
    }
    updateError = () => {
        let error = this.state.error + 1;
        if (error == 3) {
            error = 0;
            this.togglePlayer();
        }
        this.setState(
            {
                error: error
            },
            () => console.log("CANVA ERROR TOTAL ", error)
        )
    }
    resetRoundScore = () => {
        const roundScore = this.state.roundScore;
        this.setState(
            {
                roundScore: 0,
            },
            () => console.log("Round Score ", roundScore)
        )
    }
    /* updates the round score. */
    updateRoundScore = (key) => {
        const roundScore = this.state.cardData[this.state.round][key].score + this.state.roundScore;
        this.setState(
            {
                roundScore: roundScore
            },
            () => console.log("Round Score " + roundScore)
        )
    }
    updateScore = () => {
        const currentPlayer = this.state.currentPlayer;
        const points = this.state.points;
        points[currentPlayer] += this.state.roundScore;
        this.setState({ points: points },
            console.log("points", this.state.points));

    }
    handleOnKeyPress = (event) => {
        /* HANDLING THE CARD FLIPS */
        const key = event.keyCode - 49;
        if (key >= 0 && key < 6) {
            this.updateRoundScore(key);
            this.toggleCard(key);
            console.log(key)
        }
        /* ON PRESS X UPDATE KEY */
        else if (event.keyCode === 88) {
            this.updateError();
            console.log(event.keyCode);
        }
        /* HANDLING THE players FLIPS */
        else if (event.keyCode === 80) {
            this.togglePlayer();
        }

    }
    togglePlayer = () => {
        const newPlayer = (this.state.currentPlayer == 1) ? 0 : 1;
        this.setState({ currentPlayer: newPlayer }, console.log(this.state.currentPlayer, "player"))
    }
    toggleShowX = () => {
        const showX = (this.state.showX) ? false : true;
        this.setState(
            {
                showX: showX
            },
            () => console.log("toggle showX" + showX)
        )
    }

    toggleCard = (index) => {
        let cardShow = this.state.cardShow;
        cardShow[index] = true;
        this.setState(
            {
                cardShow: cardShow
            },
            () => console.log("Cards st" + cardShow)
        );
    }
    setCards = () => {
        let cardShow = [false, false, false, false, false, false];
        this.setState(
            {
                cardShow: cardShow
            },
            () => console.log("set Cards " + cardShow)
        );
    }
    onClickRound = (event) => {
        const round = event.target.value;
        this.updateScore();
        this.setState(
            {
                round: round,
                canvaError: 0,
                newbieError: 0,
            },
            () => console.log("NEW ROUND " + round)
        );
        this.setCards();
        this.resetRoundScore();
    }
    render() {
        return (
            <div className="family">
                <Header
                    players={this.state.players}
                    scores={this.state.points}
                    gameName={this.state.gameName}
                />
                <RoundScore
                    error={this.state.error}
                    score={this.state.roundScore}
                    round={this.state.round}
                />
                <Question
                    round={this.state.round}
                    questions={questions} />
                <Player
                    currentPlayer={this.state.currentPlayer}
                    players={this.state.players}
                />
                <Cards
                    cardData={this.state.cardData}
                    handleOnKeyPress={this.state.handleOnKeyPress}
                    cardShow={this.state.cardShow}
                    round={this.state.round}
                />
                <RoundButtons
                    length={questions.length}
                    round={this.state.round}
                    handleClick = {this.onClickRound}
                />
            </div>
        );
    }
}

